import { type FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import type { Bonus, Freespin } from '@/api/common';
import { BonusFlipItem } from '../BonusFlipItem';
import { ScBonusList } from './styled';

interface IBonusListProps {
  bonuses: (Bonus | Freespin)[];
}

export const BonusList: FC<IBonusListProps> = memo(({ bonuses }) => {
  const { t } = useTranslation('bonuses');

  return (
    <ScBonusList>
      <h3 className="title">{t('activeBonuses.title')}</h3>
      <div className="bonus-cards-container">
        {bonuses.map((bonus) => (
          <BonusFlipItem bonus={bonus} key={bonus.id} />
        ))}
      </div>
    </ScBonusList>
  );
});
